"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const FiltroBox_vue_1 = __importDefault(require("./FiltroBox.vue"));
let FiltroDebug = class FiltroDebug extends vue_property_decorator_1.Vue {
    get paramsFilters() {
        let params = lodash_1.default.pickBy(this.value, (param, key) => {
            if (typeof param === "object") {
                return param.length > 0;
            }
            return param;
        });
        if (params.precio[0] === this.filtros.precio[0] &&
            params.precio[1] === this.filtros.precio[1]) {
            delete params.precio;
        }
        if (params.antiguedad[0] === this.filtros.antiguedad[0] &&
            params.antiguedad[1] === this.filtros.antiguedad[1]) {
            delete params.antiguedad;
        }
        if (params.superficie_total[0] === this.filtros.superficie_total[0] &&
            params.superficie_total[1] === this.filtros.superficie_total[1]) {
            delete params.superficie_total;
        }
        if (params.superficie_cubierta[0] === this.filtros.superficie_cubierta[0] &&
            params.superficie_cubierta[1] === this.filtros.superficie_cubierta[1]) {
            delete params.superficie_cubierta;
        }
        return params;
    }
};
__decorate([
    vue_property_decorator_1.Prop({ type: [Object, Boolean], required: true }),
    __metadata("design:type", Object)
], FiltroDebug.prototype, "value", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Object, required: true }),
    __metadata("design:type", Object)
], FiltroDebug.prototype, "filtros", void 0);
FiltroDebug = __decorate([
    vue_property_decorator_1.Component({ components: { FiltroBox: FiltroBox_vue_1.default } })
], FiltroDebug);
exports.default = FiltroDebug;
